// extracted by mini-css-extract-plugin
export default {"team-lead-option":"TeamLeadSelect_team-lead-option__ypOiD","selected":"TeamLeadSelect_selected__A6Yb1"};